import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional, ViewChild, ViewEncapsulation } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { combineLatest, firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameSettingsService } from 'src/app/core/firebase/gameSettings.service';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { Background } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.state';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Navigation]);

@Component({
    selector: 'app-background',
    templateUrl: './background.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./background.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BackgroundComponent implements OnInit {
    @Input() backgroundsArray: Background[];
    @ViewChild('backgroundSlide') backgroundSlide: SwiperComponent;
    activeBackground$: Observable<Background>;
    myBackgrounds$: Observable<Background[]>;
    sliderOptions: SwiperOptions = {
        slidesPerView: 4,
        pagination: false,
        navigation: true,
    };
    constructor(
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
        private gameSettingsService: GameSettingsService,
        private popoverController: PopoverController,
        @Optional() public sopoDialogRef: SopoDialogRef,
        private sopoPopupService: SopoPopupService,
    ) { }

    ngOnInit() {
        this.activeBackground$ = this.gameThemeSettingsDispatcher.getActiveBackground();
        const myBackgroundsState$ = this.gameThemeSettingsDispatcher.getMyBackgroundsState();
        if (this.backgroundsArray) {
            this.myBackgrounds$ = myBackgroundsState$.pipe(
                map(myBackgrounds => this.gameSettingsService.mergeItems(myBackgrounds, this.backgroundsArray)),
            );
        } else {
            const backgroundsArrayPromise = this.gameSettingsService.loadAllItemsFromCms<Background>('backgrounds');
            this.myBackgrounds$ = combineLatest([myBackgroundsState$, backgroundsArrayPromise]).pipe(
                map(([myBackgrounds, backgroundsArray]) => this.gameSettingsService.mergeItems(myBackgrounds, backgroundsArray)),
            );
        }
    }

    getBackground(item: Background) {
        const backgroundId = GameSettingsService.getBackgroundId(item.id);

        if (item.type === 'main-stage') {
            return `url("/assets/img/backgrounds/main-stage-${backgroundId}.png")`;
        }
        if (item.type === 'image' || item.type === 'pattern') {
            return `url("/assets/img/backgrounds/${backgroundId}.png")`;
        }
        return item.value;
    }

    async onSelect(item: Background) {
        const activeBackground = await firstValueFrom(this.activeBackground$);
        if (item.id === activeBackground.id) return;
        if (this.sopoDialogRef) this.sopoDialogRef.close();
        else if (!this.backgroundsArray) this.popoverController.dismiss();
        this.gameSettingsService.markItemAsPurchasedAndSelect<Background>(item, 'backgrounds');
        return;
        if(!item.purchased){
        this.sopoPopupService
            .promptForConfirmation('app', {
                data: {
                    header: `Are you sure you want to purchase this item for ${item.price} diamonds?`,
                    okText: `Yes`,
                    cancelText: 'No'
                }
            })
            .then((confirmed) => {
                if (confirmed) {
                    this.gameSettingsService.selectAndPurchaseItem<Background>(item, 'backgrounds');
                }
            });
        }
        else {
            this.gameSettingsService.selectAndPurchaseItem<Background>(item, 'backgrounds');
        }
    }

    trackBackgrounds(index: number, background: Background): string {
        return background.id.toString();
    }

    ngOnDestroy(): void {}
}
